var render = function render(_c, _vm) {
  return _c(
    "wa-question-and-answer",
    { attrs: { id: "term", title: "Term" } },
    [
      _vm._v(
        "\n  This agreement will continue for the term specified via the "
      ),
      _c("em", [_vm._v("Web Store")]),
      _vm._v(". When that term ends, this agreement will expire.\n"),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }